module.exports = __webpack_public_path__ + "static/media/edit-survey-dark-icon.a63deef5.svg";